(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bemodest-product-combo-slider"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initSlider(section) {

    if (!section) return;

    if (section.dataset.initialized === 'true') {
      return;
    }

    const viewport =
      section.querySelector('[data-bm-viewport]');

    const track =
      section.querySelector('[data-bm-track]');

    const next =
      section.querySelector('[data-bm-next]');

    const prev =
      section.querySelector('[data-bm-prev]');

    if (!viewport || !track) return;

    section.dataset.initialized = 'true';

    let timer = null;
    let paused = false;


    function getStep() {

      const card =
        track.querySelector('.bm-product-card');

      if (!card) return 300;

      const width =
        card.getBoundingClientRect().width;

      const styles =
        window.getComputedStyle(track);

      const gap =
        parseFloat(styles.gap) || 16;

      return width + gap;

    }


    function scrollNext() {

      if (paused) return;

      const maxScroll =
        viewport.scrollWidth -
        viewport.clientWidth;

      if (maxScroll <= 5) return;

      const step = getStep();

      if (
        viewport.scrollLeft >=
        maxScroll - 5
      ) {

        viewport.scrollTo({
          left: 0,
          behavior: 'smooth'
        });

      } else {

        viewport.scrollBy({
          left: step,
          behavior: 'smooth'
        });

      }

    }


    function startAutoScroll() {

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      stopAutoScroll();

      timer = setInterval(
        scrollNext,
        3000
      );

    }


    function stopAutoScroll() {

      if (timer) {

        clearInterval(timer);

        timer = null;

      }

    }


    if (next) {

      next.addEventListener(
        'click',
        function () {

          viewport.scrollBy({
            left: getStep(),
            behavior: 'smooth'
          });

        }
      );

    }


    if (prev) {

      prev.addEventListener(
        'click',
        function () {

          viewport.scrollBy({
            left: -getStep(),
            behavior: 'smooth'
          });

        }
      );

    }


    viewport.addEventListener(
      'mouseenter',
      function () {

        paused = true;

      }
    );


    viewport.addEventListener(
      'mouseleave',
      function () {

        paused = false;

      }
    );


    viewport.addEventListener(
      'touchstart',
      function () {

        paused = true;

      },
      { passive: true }
    );


    viewport.addEventListener(
      'touchend',
      function () {

        paused = false;

      },
      { passive: true }
    );


    startAutoScroll();


    section._bmCleanup =
      function () {

        stopAutoScroll();

      };

  }


  function initAll() {

    document
      .querySelectorAll('[data-bm-slider]')
      .forEach(function (section) {

        initSlider(section);

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '[data-bm-slider]'
            )
          : null;

      if (section) {
        initSlider(section);
      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '[data-bm-slider]'
            )
          : null;

      if (
        section &&
        section._bmCleanup
      ) {

        section._bmCleanup();

      }

    }
  );


  /* ==========================================
     AJAX ADD TO CART
     ========================================== */

  document.addEventListener(
    'submit',
    async function (event) {

      const form =
        event.target.closest(
          '[data-bm-add-form]'
        );

      if (!form) return;

      event.preventDefault();

      const button =
        form.querySelector(
          '.bm-add-button'
        );

      if (!button) return;

      const originalText =
        button.textContent;

      button.disabled = true;
      button.textContent = 'ADDING...';


      try {

        const formData =
          new FormData(form);

        const response =
          await fetch(
            '{{ routes.cart_add_url }}.js',
            {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            }
          );

        if (!response.ok) {
          throw new Error(
            'Unable to add product'
          );
        }

        button.textContent = 'ADDED ✓';


        /*
          Give Shopify theme a moment,
          then refresh cart drawer.
        */

        setTimeout(
          function () {

            window.location.reload();

          },
          500
        );


      } catch (error) {

        console.error(error);

        button.disabled = false;

        button.textContent =
          originalText;

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initBemodestCarousel(section) {

    if (!section) return;

    if (section.dataset.bemodestInitialized === 'true') {
      return;
    }

    const viewport =
      section.querySelector(
        '[data-bemodest-viewport]'
      );

    const track =
      section.querySelector(
        '[data-bemodest-track]'
      );

    if (!viewport || !track) {
      return;
    }

    const cards =
      track.querySelectorAll(
        '.bemodest-mixed-recommendations__card'
      );

    if (!cards.length) {
      return;
    }

    section.dataset.bemodestInitialized = 'true';


    /* ==========================================
       AUTO SCROLL
       ========================================== */

    let timer = null;
    let paused = false;


    function getScrollAmount() {

      const firstCard =
        track.querySelector(
          '.bemodest-mixed-recommendations__card'
        );

      if (!firstCard) {
        return 300;
      }

      const cardWidth =
        firstCard.getBoundingClientRect().width;

      const trackStyles =
        window.getComputedStyle(track);

      const gap =
        parseFloat(trackStyles.gap) || 16;

      return cardWidth + gap;

    }


    function scrollNext() {

      if (paused) {
        return;
      }

      const maxScroll =
        viewport.scrollWidth -
        viewport.clientWidth;

      if (maxScroll <= 5) {
        return;
      }

      const step =
        getScrollAmount();


      if (
        viewport.scrollLeft >=
        maxScroll - 5
      ) {

        viewport.scrollTo({
          left: 0,
          behavior: 'smooth'
        });

      } else {

        viewport.scrollBy({
          left: step,
          behavior: 'smooth'
        });

      }

    }


    function startAutoScroll() {

      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      stopAutoScroll();

      timer =
        window.setInterval(
          scrollNext,
          3000
        );

    }


    function stopAutoScroll() {

      if (timer) {

        window.clearInterval(timer);

        timer = null;

      }

    }


    /* ==========================================
       PAUSE ON HOVER
       ========================================== */

    viewport.addEventListener(
      'mouseenter',
      function () {

        paused = true;

      }
    );


    viewport.addEventListener(
      'mouseleave',
      function () {

        paused = false;

      }
    );


    /* ==========================================
       MOBILE TOUCH
       ========================================== */

    viewport.addEventListener(
      'touchstart',
      function () {

        paused = true;

      },
      {
        passive: true
      }
    );


    viewport.addEventListener(
      'touchend',
      function () {

        paused = false;

      },
      {
        passive: true
      }
    );


    /* ==========================================
       START
       ========================================== */

    startAutoScroll();


    /* ==========================================
       CLEANUP
       ========================================== */

    section._bemodestCleanup =
      function () {

        stopAutoScroll();

      };

  }


  /* ==========================================
     INITIALIZE
     ========================================== */

  function initAll() {

    document
      .querySelectorAll(
        '[data-bemodest-mixed]'
      )
      .forEach(
        function (section) {

          initBemodestCarousel(section);

        }
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* ==========================================
     SHOPIFY THEME EDITOR
     ========================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '[data-bemodest-mixed]'
            )
          : null;

      if (section) {

        initBemodestCarousel(section);

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      const section =
        event.target.querySelector
          ? event.target.querySelector(
              '[data-bemodest-mixed]'
            )
          : null;

      if (
        section &&
        section._bemodestCleanup
      ) {

        section._bemodestCleanup();

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
